/**
 * AS 27 UNIDADES FEDERATIVAS DO BRASIL, para a plataforma inteira.
 *
 * ---------------------------------------------------------------------------
 * POR QUE ELA EXISTE, e o pedido tem data
 * ---------------------------------------------------------------------------
 * O fundador pediu em 13/09/2026, olhando a tela de criar consultorio: "UF do conselho
 * devera ter combo com pesquisa". Ate aqui o campo era texto livre de duas letras, e texto
 * livre em campo de dominio fechado produz sempre a mesma familia de defeito: `sp`, `Sp`,
 * `SP `, e a sigla que nao existe. O banco recusa a ultima (`crm_uf ~ '^[A-Z]{2}$'`) e as
 * tres primeiras passam so porque alguem lembrou de normalizar.
 *
 * ---------------------------------------------------------------------------
 * POR QUE AQUI, E NAO NO APP QUE PEDIU
 * ---------------------------------------------------------------------------
 * UF nao e do Medicina: e do Brasil. Endereco de paciente, conselho de outra profissao,
 * emissor de documento e nota fiscal precisam da mesma lista, e a segunda copia dela seria
 * a que envelhece. Este pacote e camada 0 e NAO IMPORTA NADA, entao front e servico podem
 * usa-la sem arrastar dependencia.
 *
 * ---------------------------------------------------------------------------
 * O QUE ELA NAO E
 * ---------------------------------------------------------------------------
 * Ela NAO valida CRM. Saber que `SE` existe nao diz nada sobre o numero valer naquele
 * conselho: isso exige consultar o CFM, e esta lista nao consulta nada. Ela fecha o
 * dominio do campo, e so.
 *
 * A ORDEM E ALFABETICA PELA SIGLA, e nao por regiao nem por populacao: quem procura uma UF
 * procura pela sigla que ja conhece, e alfabetica e a unica ordem em que a pessoa sabe onde
 * olhar antes de comecar a ler.
 */
/**
 * AS 27, congeladas.
 *
 * `Object.freeze` porque lista de dominio que alguem consegue alterar em tempo de execucao
 * deixa de ser dominio fechado: bastaria um `push` num modulo qualquer para o campo aceitar
 * uma sigla que o banco vai recusar depois, e o erro apareceria longe da causa.
 */
export const UFS_DO_BRASIL = Object.freeze([
    { sigla: 'AC', nome: 'Acre' },
    { sigla: 'AL', nome: 'Alagoas' },
    { sigla: 'AM', nome: 'Amazonas' },
    { sigla: 'AP', nome: 'Amapá' },
    { sigla: 'BA', nome: 'Bahia' },
    { sigla: 'CE', nome: 'Ceará' },
    { sigla: 'DF', nome: 'Distrito Federal' },
    { sigla: 'ES', nome: 'Espírito Santo' },
    { sigla: 'GO', nome: 'Goiás' },
    { sigla: 'MA', nome: 'Maranhão' },
    { sigla: 'MG', nome: 'Minas Gerais' },
    { sigla: 'MS', nome: 'Mato Grosso do Sul' },
    { sigla: 'MT', nome: 'Mato Grosso' },
    { sigla: 'PA', nome: 'Pará' },
    { sigla: 'PB', nome: 'Paraíba' },
    { sigla: 'PE', nome: 'Pernambuco' },
    { sigla: 'PI', nome: 'Piauí' },
    { sigla: 'PR', nome: 'Paraná' },
    { sigla: 'RJ', nome: 'Rio de Janeiro' },
    { sigla: 'RN', nome: 'Rio Grande do Norte' },
    { sigla: 'RO', nome: 'Rondônia' },
    { sigla: 'RR', nome: 'Roraima' },
    { sigla: 'RS', nome: 'Rio Grande do Sul' },
    { sigla: 'SC', nome: 'Santa Catarina' },
    { sigla: 'SE', nome: 'Sergipe' },
    { sigla: 'SP', nome: 'São Paulo' },
    { sigla: 'TO', nome: 'Tocantins' },
]);
/**
 * A lista no formato que a peca `Selecao` consome.
 *
 * O ROTULO CARREGA A SIGLA E O NOME (`SP · São Paulo`), e nao um dos dois. Com so a sigla,
 * quem nao a sabe de cor precisa adivinhar; com so o nome, quem sabe precisa ler a lista
 * inteira para achar o que ja conhecia. Os dois juntos deixam a busca funcionar pelos dois
 * caminhos, que e o que o combo com pesquisa existe para permitir.
 *
 * O SEPARADOR E O PONTO MEDIO, e nao o travessao, pela regra dura da casa.
 */
export const UFS_PARA_SELECAO = Object.freeze(UFS_DO_BRASIL.map((uf) => ({ valor: uf.sigla, rotulo: `${uf.sigla} · ${uf.nome}` })));
/**
 * A sigla existe? Comparacao em MAIUSCULA e sem espaco, do mesmo jeito que o indice do
 * banco normaliza (`upper(crm_uf)`), para a tela e o banco nunca discordarem sobre o que e
 * a mesma UF.
 */
export function ufExiste(sigla) {
    if (!sigla)
        return false;
    const alvo = sigla.trim().toUpperCase();
    return UFS_DO_BRASIL.some((uf) => uf.sigla === alvo);
}
//# sourceMappingURL=ufs.js.map